const SET = 'scroll/scrollKept/SET'

export const setScrollKept = scrollKept => {
  return {
    scrollKept,
    type: SET,
  }
}

export default (state = false, action) => {
  switch (action.type) {
    case SET:
      return action.scrollKept
    default:
      return state
  }
}
